import { Params } from './usePlayerAudioFocus.types.ts';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function usePlayerAudioFocus(_: Params) {
    // Player audio focus change logic is not needed for Web player
}

export default usePlayerAudioFocus;
